export function parseObservations(bundle) {
  const results = { vitals: [], labs: [] };

  const vitalsMap = {
    "8480-6": { label: "Systolic BP", order: 1 },
    "8462-4": { label: "Diastolic BP", order: 2 },
    "8867-4": { label: "Heart Rate", order: 3 },
    "8310-5": { label: "Body Temperature", order: 4 },
    "2710-2": { label: "Oxygen Saturation", order: 5 },
    "29463-7": { label: "Body Weight", order: 6 },
    "8302-2": { label: "Height", order: 7 },
    "39156-5": { label: "Body Mass Index", order: 8 },
    "72514-3": { label: "Pain Score", order: 9 },
  };

  const normalizeUnit = (unit) => {
    if (!unit) return "";
    return unit
      .replace("{score}", "")
      .replace("mm[Hg]", "mmHg")
      .replace("kg/m2", "kg/m²")
      .trim();
  };

  bundle.entry?.forEach((entry) => {
    const obs = entry.resource;
    const coding = obs.code?.coding?.[0];
    const code = coding?.code;
    const date = obs.effectiveDateTime;
    const id = obs.id; // FHIR Observation ID

    // Blood pressure panels
    if (code === "85354-9" || code === "55284-4") {
      obs.component?.forEach((comp) => {
        const compCode = comp.code?.coding?.[0]?.code;
        const compValue = comp.valueQuantity?.value;
        const compUnit = normalizeUnit(comp.valueQuantity?.unit);

        if (vitalsMap[compCode]) {
          results.vitals.push({
            id: `${id}-${compCode}`, // make component IDs unique
            label: vitalsMap[compCode].label,
            order: vitalsMap[compCode].order,
            value: compValue?.toFixed(1),
            unit: compUnit,
            date,
          });
        }
      });
      return;
    }

    // Single-value vitals
    const isVital = obs.category?.some((cat) =>
      cat.coding?.some(
        (c) =>
          c.system === "http://terminology.hl7.org/CodeSystem/observation-category" &&
          c.code === "vital-signs"
      )
    );

    if (isVital && vitalsMap[code]) {
      let unit = normalizeUnit(obs.valueQuantity?.unit);
      if (code === "72514-3") unit = ""; // Pain Score has no unit

      results.vitals.push({
        id,
        label: vitalsMap[code].label,
        order: vitalsMap[code].order,
        value: obs.valueQuantity?.value ? Number(obs.valueQuantity.value.toFixed(1)) : null,
        unit,
        date,
      });
      return;
    }

    // Lab results
    const isLab = obs.category?.some((cat) =>
      cat.coding?.some(
        (c) =>
          c.system === "http://terminology.hl7.org/CodeSystem/observation-category" &&
          c.code === "laboratory"
      )
    );

    if (isLab) {
      results.labs.push({
        id,
        label: coding?.display || obs.code?.text || "Unknown Lab Test",
        value: obs.valueQuantity?.value ? Number(obs.valueQuantity.value.toFixed(1)) : null,
        unit: normalizeUnit(obs.valueQuantity?.unit),
        date,
      });
    }
  });

  results.vitals.sort((a, b) => (a.order || 99) - (b.order || 99));
  return results;
}